import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../common/CommonStyledComponents';
import NumberPillInput from '../../controls/NumberPillInput/NumberPillInput';

class OrderItemsSelectItem extends Component {
  propTypes = {
    active: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    max: PropTypes.number.isRequired,
    handleSelectItem: PropTypes.func.isRequired,
    handleItemQtyChange: PropTypes.func.isRequired,
    disableControls: PropTypes.bool,
  };

  render() {
    const { active, id, name, qty, max, handleSelectItem, handleItemQtyChange, disableControls = false } = this.props;

    return (
      <Styled.ItemRow key={id}>
        {!disableControls && <Styled.Checkbox type="checkbox" checked={active} onChange={() => handleSelectItem(id)} />}
        <Styled.RowContent>
          <Styled.ItemDetail active={active}>{name}</Styled.ItemDetail>
          {active && !disableControls && (
            <NumberPillInput
              qty={qty}
              min={0}
              step={1}
              max={max}
              onChange={(newQty) => handleItemQtyChange(id, newQty)}
            />
          )}
        </Styled.RowContent>
      </Styled.ItemRow>
    );
  }
}

export default OrderItemsSelectItem;
